<template>
  <CDropdown variant="nav-item" class="d-none d-md-flex">
    <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
      <CAvatar :src="avatar" size="md" />
      <span class="h6">{{ userDetails.email }}</span>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownItem @click="resub">
        <CIcon icon="cil-user" /> Re-Subscribe
      </CDropdownItem>
      <CDropdownItem @click="logout">
        <CIcon icon="cil-lock-locked" /> Logout
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
// import avatar from '@/assets/images/avatars/8.jpg'
import { mapActions } from 'vuex'

export default {
  name: 'AppHeaderDropdownAccnt',
  setup() {
    return {
      avatar: '',
      itemsCount: 42,
    }
  },
  computed: {
    userDetails: function () {
      return this.$store.getters.StateUser
    },
  },
  methods: {
    ...mapActions(['restoreEmail']),
    async logout() {
      let state = this.$store.state
      let newState = {}

      Object.keys(state).forEach((key) => {
        if (key != 'sidebarUnfoldable' && key != 'sidebarVisible') {
          newState[key] = {}
        }
      })

      this.$store.replaceState(newState)
      await this.$store.dispatch('LogOut')
      this.$router.push('/login')
    },
    async resub() {
      let user = this.$store.getters.StateUser
      const resp = await this.restoreEmail({
        user_id: user.userID,
        email: user.email,
      })
      alert(resp.message)
    },
  },
}
</script>
